module.exports = __webpack_public_path__ + "static/football-a5fb6504409563e0d639533927e7ac54.jpg";